class CommentThread {
  constructor(container) {
    this.element = container;
    this.replyForm = container.querySelector('.comment-form');
    this.replyEditor = this.replyForm.querySelector('.comment-editor');
    this.closeReplyBtn = this.replyForm.querySelector('.close-reply-btn');

    this.element.querySelectorAll('[data-comment-reply-button]').forEach((el) => {
      el.addEventListener('click', this.openReplyForm.bind(this));
    });

    this.closeReplyBtn.addEventListener('click', this.closeReplyForm.bind(this));
  }

  openReplyForm(e) {
    e.preventDefault();
    this.replyEditor.value = `@${e.target.getAttribute('data-author-username')} `;
    this.replyForm.style.display = 'block';
    this.replyEditor.focus();
  }

  closeReplyForm(e) {
    e.preventDefault();
    this.replyForm.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-comment-thread]').forEach((el) => new CommentThread(el));
});
